const available_languages_options = [
  { label: "Polski", value: "pl" },
  { label: "Niemiecki", value: "de" },
  { label: "Angielski", value: "en" },
  { label: "Francuski", value: "fr" },
  { label: "Hiszpański", value: "es" },
  { label: "Włoski", value: "it" },
  { label: "Niderlandzki", value: "nl" },
  { label: "Szwedzki", value: "sv" },
  { label: "Bułgarski", value: "bg" },
  { label: "Rumuński", value: "ro" },
  { label: "Węgierski", value: "hu" },
];

export const getLanguageName = (code) =>
  available_languages_options.find(({ value }) => value === code)?.label;

export default available_languages_options;
